/**
 * @title: Main Application Component
 * @module: App
 * @type: Component
 * @dependencies: [
 *   - react-router-dom
 *   - react-i18next
 * ]
 * @dataFlow: [
 *   Input: None
 *   Output: Rendered application with routing
 * ]
 * @filepath: src/App.tsx
 */

import React from 'react';
import './config/i18n';
import './styles/globals.css';
import LandingPage from './pages/LandingPage';

function App() {
  return (
    <div className="min-h-screen bg-background">
      <LandingPage />
    </div>
  );
}

export default App; 